import { render } from "./SelecionarPrecoProdutoMovimento.vue?vue&type=template&id=d6264cae&ts=true"
import script from "./SelecionarPrecoProdutoMovimento.vue?vue&type=script&lang=ts"
export * from "./SelecionarPrecoProdutoMovimento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__